module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "wrapper-404",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'dashboard'
        })
      }
    }
  }, [_c('div', {
    staticClass: "error-404"
  }, [_vm._m(0), _vm._v(" "), _c('h1', [_c('vue-typer', {
    attrs: {
      "text": _vm.text,
      "repeat": Infinity,
      "shuffle": false,
      "initial-action": "typing",
      "pre-type-delay": 70,
      "type-delay": 70,
      "pre-erase-delay": 2000,
      "erase-delay": 250,
      "erase-style": "clear",
      "erase-on-complete": false,
      "caret-animation": "solid"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "moon"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-number"
  }, [_c('span', [_vm._v("4")]), _vm._v(" "), _c('span', [_c('img', {
    staticClass: "icon has-animation",
    attrs: {
      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', [_vm._v("3")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6bf27602!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/403.vue
// module id = 1158
// module chunks = 2